import BaseFeature from '../../foundation/base/base';

class DetectBrowser extends BaseFeature {
	constructor(element) {
		super(element);

		const isIE = DetectBrowser.detectIE();

		if (isIE !== false) {
			document.body.classList.add('browser-is-ie');
		}
	}

	// Detect IE
	static detectIE() {
		const ua = window.navigator.userAgent;

		const msie = ua.indexOf('MSIE ');
		if (msie > 0) {
			// IE 10 or older => return version number
			return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
		}

		const trident = ua.indexOf('Trident/');
		if (trident > 0) {
			// IE 11 => return version number
			const rv = ua.indexOf('rv:');
			return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
		}

		// other browser
		return false;
	}
}

export default DetectBrowser;
